const pad = number => String(number).padStart(2, '0');
export const dayKey = date => `${String(date.getFullYear()).padStart(4, '0')}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
export function parseDay(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(0); date.setFullYear(year, month - 1, day); date.setHours(12, 0, 0, 0);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}
export function addDays(date, days) { const next = new Date(date); next.setDate(next.getDate() + days); return next; }
export function monthStart(date, offset = 0) { return new Date(date.getFullYear(), date.getMonth() + offset, 1, 12); }
export function weekStart(date, firstDay = 0) { const result = new Date(date); result.setHours(12, 0, 0, 0); return addDays(result, -((result.getDay() - firstDay + 7) % 7)); }
export function calendarMonthDays(date, firstDay = 0) { const start = weekStart(monthStart(date), firstDay); return Array.from({ length: 42 }, (_, index) => addDays(start, index)); }
export function calendarWeekDays(date, firstDay = 0) { const start = weekStart(date, firstDay); return Array.from({ length: 7 }, (_, index) => addDays(start, index)); }
export function localeWeekStart() {
  try { const locale = new Intl.Locale(navigator.language); const info = locale.weekInfo || locale.getWeekInfo?.(); return info ? info.firstDay % 7 : 0; }
  catch { return 0; }
}
export function noteCalendarDate(note) {
  if (note?.scheduled_at) {
    const legacyDay = parseDay(note.scheduled_at);
    if (legacyDay) return { day: dayKey(legacyDay), date: legacyDay, timed: false, time: '' };
    if (/^\d{4}-\d{2}-\d{2}/.test(note.scheduled_at) && !parseDay(note.scheduled_at.slice(0, 10))) return null;
    const date = new Date(note.scheduled_at);
    if (!Number.isNaN(date.getTime())) return { day: dayKey(date), date, timed: true, time: `${pad(date.getHours())}:${pad(date.getMinutes())}` };
  }
  const date = parseDay(note?.detected_date);
  return date ? { day: dayKey(date), date, timed: false, time: '' } : null;
}
export function friendlyDay(value, reference = new Date()) {
  const date = typeof value === 'string' ? parseDay(value) : value;
  if (!date) return '';
  if (dayKey(date) === dayKey(reference)) return 'Today';
  if (dayKey(date) === dayKey(addDays(reference, 1))) return 'Tomorrow';
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', ...(date.getFullYear() !== reference.getFullYear() ? { year: 'numeric' } : {}) });
}
export function formatNoteSchedule(note) {
  const placement = noteCalendarDate(note);
  if (!placement) return '';
  return `${friendlyDay(placement.day)} · ${placement.timed ? placement.date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' }) : 'Untimed'}`;
}
export function compareCalendarNotes(a, b) {
  const x = noteCalendarDate(a), y = noteCalendarDate(b);
  if (x?.day !== y?.day) return (x?.day || '').localeCompare(y?.day || '');
  if (x?.timed !== y?.timed) return x?.timed ? 1 : -1;
  return (x?.time || '').localeCompare(y?.time || '') || a.text.localeCompare(b.text);
}
export function noteTextParts(text = '') {
  const value = text.replace(/\r\n/g, '\n');
  const index = value.indexOf('\n');
  if (index < 0) return { title: value, notes: '', separator: '\n\n' };
  const rest = value.slice(index + 1);
  return { title: value.slice(0, index), notes: rest.startsWith('\n') ? rest.slice(1) : rest, separator: rest.startsWith('\n') ? '\n\n' : '\n' };
}
export function composeNoteText(title, notes, separator = '\n\n') { return `${title.trim()}${notes.trim() ? separator + notes.trim() : ''}`; }
export function editorCalendarPatch(date, time) {
  if (!date) return { scheduled_at: null, detected_date: null };
  if (!parseDay(date)) throw new Error('Please choose a valid date.');
  if (!time) return { scheduled_at: null, detected_date: date };
  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) throw new Error('Please choose a valid time.');
  const stamp = `${date}T${time}:00`, parsed = new Date(stamp);
  if (Number.isNaN(parsed.getTime()) || dayKey(parsed) !== date || `${pad(parsed.getHours())}:${pad(parsed.getMinutes())}` !== time) throw new Error('That local time is unavailable. Please choose another time.');
  return { scheduled_at: stamp, detected_date: null };
}